<!--
 * @Author: Jason
 * @Date: 2019-10-15 17:32:50
 * @version: 
 * @LastEditors: Jason
 * @LastEditTime: 2019-10-31 18:57:23
 * @Descripttion: 
 -->
<template>
  <div>
    <v-head :isShowBack="$route.meta.isShowIcon">门店列表</v-head>
    <div class="flex-btwn-aic point-classify">
      <div class="flex-jcc-aic point-classify-item" @click="toDrowMenu()">
        <div class="point-classify-item-city">{{areaName}}</div>
        <span class="el-icon-caret-bottom color-gree"></span>
      </div>
      <div class="flex-btwn-aic point-search">
        <div class="flex-aic point-search-info" >
          <img @click="search()" src="../../assets/imgs/icon_search.png" alt="">
          <input type="text" v-model="searchText" @input='inputChange()'  @keyup.enter="search()" placeholder="请输入关键字搜索">
        </div>
        <div class="point-search-off" v-show="isShowOff" @click="cancalSearch()">取消</div>
      </div>
    </div>

    <!-- 城市选择和服务选择蒙层 -->
    <transition name="fade">
      <div class="point-mask" v-show="isShowMask">
        <div class="point-info-list">
          <div class="point-info-item" @click="chooseService('0')">全城</div>
          <div
            class="point-info-item"
            v-for="(item, index) in cityList"
            :key="index"
            @click="chooseService(item)"
          >{{item.name}}</div>
        </div>
      </div>
    </transition>

    <!-- 网点列表 -->
    <div
      class="point-list"
      v-if="webList&&webList.length>0"
      v-infinite-scroll="loadMore"
      infinite-scroll-immediate-check="false"
      :infinite-scroll-disabled="isEnd"
      infinite-scroll-distance="10"
    >
      <div class="flex-btwn-aic point-item" v-for="(item, index) in webList" :key="index">
        <img class="point-item-logo" :src="item.logoPath || logoImg" alt />
        <div class="point-info">
          <div class="point-item-name">{{item.shopName}}</div>
          <div class="point-item-address">{{item.address}}</div>
          <div class="flex-btwn-aic">
            <div class="point-item-time-tel">
              <div class="flex-aic">
                <!-- <img src="../../assets/imgs/icon_time.png" alt /> -->
                <span>营业时间：</span>
                <span>{{item.openTime}} -{{item.restTime}}</span>
              </div>
              <div class="flex-aic" @click="toTel(item.telephone)">
                <!-- <img src="../../assets/imgs/icon_tel.png" alt /> -->
                <span>联系方式：</span>
                <span class="color-blue">{{item.telephone}}</span>
              </div>
            </div>
            <div class="point-item-nav" @click="toNav(item)">
              <div class="color-c7">{{item.shopDistance}}</div>
              <div class="point-item-to-nav">导航</div>
              
            </div>
          </div>
        </div>
      </div>
      <div class="load-more" v-show="!isEnd">
        <span class="el-icon-loading"></span>努力加载中...
      </div>
      <div class="no-more" v-show="noData">我也是有底线的哦~</div>
    </div>
    <div v-else class="no-data">暂无更多数据</div>
  </div>
</template>
<script>
import vHead from "@/components/vHead.vue";
import { GetLoc } from "@/assets/js/utils.js";
import { GetPost } from "@/api/point.js";
export default {
  components: {
    vHead
  },

  data() {
    return {
      logoImg:require("../../assets/imgs/icon_logo.png"),
      isShowMask: false,
      cityList: [],
      serviceText: "服务",
      areaName: "",
      areaId: null,
      webList: [],
      isEnd: false,
      noData: false,
      pageNum: 1,
      scrollY:0,
      searchText:'',
      // widthVal:'100%'
    };
  },
  computed:{
    isShowOff(){
      let _ = this
      _.searchText = _.searchText.replace(/(^\s*)|(\s*$)/g, "")
      if(_.searchText){
        // _.widthVal = 'calc(100%-12vw)'
        return true
      } else{
        return false
      }
    }
  },
  mounted(){
    let _ = this;
    document.body.style.backgroundColor = '#F4F5F7'

    if(sessionStorage.cityName){
      _.areaName = sessionStorage.cityName
      return
    }
    if(sessionStorage.city && sessionStorage.city != 'null' && sessionStorage.city != 'undefined'){
      _.areaName = sessionStorage.city
    }else{
      GetLoc(()=>{
        _.areaName = sessionStorage.city
      })
      
    }
  },
  created() {
    let _ = this;
    _.getAreaList();
    _.getShopList();
    
  },
  methods: {
    inputChange(){
      let _ = this

    },
    cancalSearch(){
      let _ = this
      _.searchText = ''
      _.search()
    },
    search(){
      let _ = this
      _.pageNum = 1;
      _.webList = [];
      _.isEnd = false;
      _.noData = false;
      document.body.style = ''
      window.scrollTo(0, this.scrollY)
      _.getShopList();
    },
    getShopList() {
      let _ = this;
      let cityName = sessionStorage.cityName || sessionStorage.city
      let pars = {
        url:'http://csp.schengle.com/csp-web-website/webShop/shopList',
        params: { 
          sourceCode: "NHSXETC",
          pageNo: _.pageNum,
          pageSize: 10,
          coordinate:sessionStorage.longitude+','+sessionStorage.latitude,
          // longitude: sessionStorage.longitude,
          // latitude: sessionStorage.latitude,
          cityName: cityName,
          areaId: _.areaId,
          shopName:_.searchText
        }
      };
      GetPost(pars)
        .then(res => {
          
          let shopList = JSON.parse(res.result).shopSiteVO;
          console.log("====>", shopList);
          shopList = shopList.map(i => {
            if (i.shopDistance) {
              i.shopDistance = i.shopDistance.toLowerCase();
            }
            return i;
          });
          
          if (_.pageNum == 1) {
            _.webList = shopList;
          } else {
            _.webList = _.webList.concat(shopList);
          }

          if (shopList.length < 10) {
            _.isEnd = true;
            _.noData = true;
            
          } else {
            _.isEnd = false;
          }
          // if (_.pageNum*10 < res.totalSize) {
            
          //   _.isEnd = false;
          // } else {
          //   _.isEnd = true;
          //   _.noData = true;
          // }
        })
        .catch(err => {
          console.log("执行错误", err);
          if (err && err.resultDesc) {
            _.toast(err.resultDesc);
          }
        });
    },
    loadMore() {
      let _ = this;
      if (_.isEnd) return;
      _.isEnd = true;
      _.pageNum++;
      _.getShopList();
      console.log("jjjj");
    },
    // 选择服务
    chooseService(i) {
      let _ = this;
      if (i == "0") {
        _.areaName = sessionStorage.cityName || sessionStorage.city;
        _.areaId = null;
      } else {
        _.areaName = i.name;
        _.areaId = i.areaId;
      }
      _.pageNum = 1;
      _.webList = [];
      _.isEnd = false;
      _.noData = false;
      document.body.style = ''
      window.scrollTo(0, this.scrollY)
      _.getShopList();
      _.isShowMask = false;
    },
    getAreaList() {
      let _ = this;
      let cityName = sessionStorage.cityName || sessionStorage.city
      let pars = {
        url:'http://csp.schengle.com/csp-web-website/webArea/getSourceShopAreaList',
        params: { cityName:sessionStorage.cityName }
      };
      GetPost(pars)
        .then(res => {
          
          var list = JSON.parse(res.result).shopSiteAreaTreeVO
          console.log("res=>",list)
          list = list.filter( i => {
            return i.type == 2
          })
          _.cityList = list;
          console.log("_.cityList",_.cityList)
        })
        .catch(err => {
          if (err && err.resultDesc) {
            _.toast(err.resultDesc);
          }
        });
    },
    toDrowMenu(val) {
      let _ = this;
      _.isShowMask = true;
      
      _.scrollY = window.scrollY 
      // body定位的top就是滚动的距离
      document.body.style = `position:fixed;top:-${this.scrollY}px;height:100%;width:100%;overflow: hidden;`
    },
    toNav(i) {
      let _ = this;
      console.log("点击去导航", i);
      _.$router.push({
        path: `/shop/nav`,
        query: {
          coordinate: i.coordinate,
          address: i.address
        }
      });
    },
    toTel(tel){
      window.location.href = `tel:${tel}`
    }
  }
};
</script>
<style lang="scss" scoped>
.scrollY{
  touch-action:none;
  -moz-touch-action:none;
  -ms-touch-action:none;
  -webkit-touch-action:none;
}

.point-classify {
  height: 12vw;
  width: 100%;
  border-top: 1px solid #F4F5F7;
  background-color: #fff;
  position: fixed;
  top:12vw;
  left: 0;
  right: 0;
  z-index: 10;
  .point-classify-item {
    width: 30%;
    text-align: center;
    height: 12vw;
    line-height: 12vw;
    font-size: 4vw;
    .point-classify-item-city{
      width: 80%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .point-search{
    width: 70%;
    height: 9vw;
    padding-right: 4vw;
    .point-search-info{
      height: 9vw;
      background-color: #F8F8F8;
      padding: 0 2vw;
      border-radius: 1.3333vw;
      overflow: hidden;
      // width: calc(100%-12vw);
      flex: 1;
      -webkit-flex: 1;
      -moz-flex: 1;
      -ms-flex: 1;
      -o-flex: 1;
      img{
        width: 4.2667vw;
        height: auto;
        margin-right: 2vw;
      }
      input{
        height: 100%;
        background-color: transparent;
        flex: 1;
        -webkit-flex: 1;
        -moz-flex: 1;
        -ms-flex: 1;
        -o-flex: 1;
      }
    }
    .point-search-off{
      width: 12vw;
      text-align: right;
      height: 9vw;
      line-height: 9vw;
      color:#666;
      font-size: 4vw;
    }
  }
}
.point-mask {
  border-top: 1px solid #F4F5F7;
  background-color: #fff;
  position: fixed;
  top: 24vw;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  overflow-y: auto;
  .point-info-list {
    // width: 100%;
    // height: 100%;
    // overflow-y: scroll;
    // background-color: #fff;
    // border-top: 1px solid #F4F5F7;
    .point-info-item {
      height: 12vw;
      text-align: center;
      font-size: 4vw;
      line-height: 12vw;
      background-color: #fff;
      border-bottom: 1px solid #ededed;
    }
  }
}
.point-list {
  width: 100%;
  margin-top: 24vw;
  padding: 2.6667vw 0 6vw;
  .point-item {
    padding: 4vw;
    width: 100%;
    background-color: #fff;
    margin-bottom: 2.6667vw;
    .point-item-logo {
      width: 26.4vw;
      height: auto;
      display: inline-block;
      margin-right: 4.8vw;
    }
    .point-info {
      flex: 1;
      -ms-flex: 1;
      -webkit-flex: 1;
      -moz-flex: 1;
      overflow: hidden;
      .point-item-name {
        width: 100%;
        font-size: 4vw;
        font-weight: bold;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        margin-bottom: 2vw;
      }
      .point-item-address {
        font-size: 3.4667vw;
        // white-space: nowrap;
        // text-overflow: ellipsis;
        // overflow: hidden;
        margin-bottom: 2vw;
      }
      .point-item-time-tel {
        font-size: 3.2vw;
        div:first-child {
          margin-bottom: 2.6667vw;
        }
        img {
          width: 4vw;
          display: inline-block;
          margin-right: 2vw;
        }
      }
      .point-item-nav {
        text-align: center;
        font-size: 3.2vw;
        .point-item-to-nav {
          height: 6vw;
          padding: 0 4vw;
          background-color: #16A085;
          color: #fff;
          font-size: 3.2vw;
          line-height: 6vw;
          border-radius: 3vw;
          margin-top: 2vw;
        }
      }
    }
  }
}
</style>


